import type { Appearance } from '@stripe/stripe-js'

export const STRIPE_APPEARANCE: Appearance = {
  labels: 'above',
  variables: {
    fontSizeBase: '14px',
    fontWeightNormal: '400',
    fontWeightMedium: '500',
    fontLineHeight: '150%',
    colorPrimary: '#216752',
    colorBackground: '#ffffff',
    colorText: '#4f4f4f',
    colorTextSecondary: '#6e6e6d',
    colorTextPlaceholder: '#989796',
    colorIcon: '#6e6e6d',
    colorDanger: '#df1c41',
    colorSuccess: '#216752',
    colorWarning: '#a1720c',
    borderRadius: '8px',
    spacingUnit: '4px',
    gridRowSpacing: '16px',
    gridColumnSpacing: '12px',
    focusBoxShadow: '0 0 0 1px #121212',
    focusOutline: 'none',
  },
  rules: {
    '.Label': {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '120%',
      color: '#121212',
      marginBottom: '8px',
    },
    '.Input': {
      padding: '8px 16px',
      border: '1px solid #d5d4d2',
      boxShadow: '0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a',
      color: '#4f4f4f',
    },
    '.Input:focus': {
      border: '1px solid #d5d4d2',
      boxShadow: '0 0 0 1px #121212',
    },
    '.Input--invalid': {
      border: '2px solid #ed8296',
      boxShadow: 'none',
      color: '#4f4f4f',
    },
    '.Input:disabled': {
      backgroundColor: '#f0eeea',
      opacity: '0.5',
    },
    '.Error': {
      color: '#df1c41',
      fontSize: '14px',
      marginTop: '8px',
    },
  },
}
